import { FlattenSimpleInterpolation, css } from 'styled-components';

import { isKiosk, isNative } from 'utils/environment';

type MediaQueryTaggedTemplate = (
  template: TemplateStringsArray,
  ...args: string[]
) => FlattenSimpleInterpolation;

type MediaQueries = {
  [name: string]: MediaQueryTaggedTemplate;
};

const mediaQueries: MediaQueries = {
  mobile: (template, ...args) => css`
    @media screen and (max-width: 812px) {
      ${css(template, ...args)}
    }
  `,
  mobileTiny: (template, ...args) => css`
    @media screen and (max-width: 374px) {
      ${css(template, ...args)}
    }
  `,
  mobileSmall: (template, ...args) => css`
    @media screen and (max-width: 670px) {
      ${css(template, ...args)}
    }
  `,
  mobileLandscape: (template, ...args) => css`
    @media screen and (max-width: 812px) and (orientation: landscape) {
      ${css(template, ...args)}
    }
  `,
  desktop: (template, ...args) => css`
    @media screen and (min-width: 813px) {
      ${css(template, ...args)}
    }
  `,
  desktopLarge: (template, ...args) => css`
    @media screen and (min-width: 1200px) {
      ${css(template, ...args)}
    }
  `,
  desktopNotKiosk: (template, ...args) => {
    if (!isKiosk) {
      return css`
        @media screen and (min-width: 813px) {
          ${css(template, ...args)}
        }
      `;
    }
    return '' as any;
  },
  mobileFullscreen: (template, ...args) => css`
    @media screen and (display-mode: standalone) {
      ${css(template, ...args)}
    }
    ${isNative && css(template, ...args)}/* apply full-screen display logic to capacitor */
  `,
  kiosk: (template, ...args) => {
    if (isKiosk) {
      return css(template, ...args);
    }
    return '' as any;
  },
};

export default mediaQueries;
